import { createAsyncAction } from 'typesafe-actions';
import * as types from './quizAssociationOptions.actionTypes';
import { QuizAssociationOptions } from './type';

export const fetchQuizAssociationOptions = createAsyncAction(
	types.FETCH_QUIZ_ASSOCIATION_OPTIONS_REQUEST,
	types.FETCH_QUIZ_ASSOCIATION_OPTIONS_SUCCESS,
	types.FETCH_QUIZ_ASSOCIATION_OPTIONS_FAILED,
)<undefined, { quizAssociationOptions: QuizAssociationOptions }, { error: string }>();
